import React from "react";
import styled from "@emotion/styled";
import { ElementRoot } from "@whalecloud/page-builder-core/components/ElementRoot";

const ColumnContainer = styled("div")({
  position: "relative",
  flex: "1 100%",
  boxSizing: "border-box",
  height: "100%",
  width: "100%",
  zIndex: 20,
  display: "flex"
});

const HeaderCell = (props: any) => {
  const { element } = props;

  const { columnSettings } = element.data;

  return (
    <ColumnContainer style={{ justifyContent: "center" }}>
      <ElementRoot
        element={element}
        className={`webiny-pb-base-page-element-style webiny-pb-layout-table-header-cell`}
        style={{ width: "100%", display: "flex", flexDirection: "column" }}
      >
        {columnSettings.title}
      </ElementRoot>
    </ColumnContainer>
  );
};

export default React.memo(HeaderCell);
